var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instructions"},[_c('span',{staticClass:"bold"},[_vm._v(" חיבור חשבון משותף")]),_vm._v("\n  עם שם משתמש וסיסמא:\n")])}]

export { render, staticRenderFns }